import { render, staticRenderFns } from "./BlogBottomBackground.vue?vue&type=template&id=38064289&scoped=true&"
import script from "./BlogBottomBackground.vue?vue&type=script&lang=js&"
export * from "./BlogBottomBackground.vue?vue&type=script&lang=js&"
import style0 from "./BlogBottomBackground.vue?vue&type=style&index=0&id=38064289&scoped=true&lang=css&"
import style1 from "./BlogBottomBackground.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38064289",
  null
  
)

export default component.exports